package fr.frux.core.network.api

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.network.ApiPaths
import fr.frux.shared.dto.PlaceSearchResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.retry
import io.ktor.client.request.get
import io.ktor.client.request.parameter

/**
 * Recherche de lieux (#394) : proxy backend vers le géocodeur, public, au plus cinq lieux. Les
 * bornes (3 à 100 caractères) sont celles du serveur, qui répond 400 INVALID_QUERY en dehors et
 * 503 GEOCODER_UNAVAILABLE en panne fournisseur, deux cas traduits par le client en exception.
 */
interface PlacesApi {
    suspend fun searchPlaces(query: String): PlaceSearchResponse
}

@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class PlacesApiImpl(
    private val httpClient: HttpClient,
) : PlacesApi {
    override suspend fun searchPlaces(query: String): PlaceSearchResponse =
        httpClient
            .get("${ApiPaths.V1}/places/search") {
                parameter("q", query)
                // La recherche suit la frappe : rejouer un 503 pendant une panne du géocodeur
                // triplerait les appels pour une réponse que la frappe suivante aura périmée.
                retry { noRetry() }
            }.body()
}
